//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ModelSelect, ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import UMUM from "../../library/umum.js";
import DATA_MASTER from "../../library/dataMaster";

export default {
  components: {
    ModelSelect,
    ModelListSelect
  },
  data() {
    return {
      form: {
        id: "",
        nama: "",
        nip: "",
        gelar_depan: "",
        gelar_belakang: "",
        ttl: "",
        tempat_lahir: "",
        jenis_kelamin: "",
        status_keluarga: "",
        status_keluarga_uraian: "",
        agama: "",
        agama_uraian: "",
        pendidikan_ahir: "",
        pendidikan_ahir_uraian: "",
        sekolah: "",
        thn_lulus: "",
        tmt_cpns: "",
        gol: "",
        gol_uraian : "",
        tmt_golongan: "",
        jabatan: "",
        tmt_jabatan: "",
        no_karpeg: "",
        taspen: "",
        NPWP: "",
        alamat: "",
        kota_asal: "",
        kode_pos: "",
        kontak: "",
        tmt_gol: "",
        nm_sekolah: "",
        pendidikan_formal_thn_lulus: "",
        file: null,
        file_old: "",
        unit_kerja: ""
      },
      data : {
        data_karpeg_id : '',
        no_registrasi : '',
        no_kepegawaian : '',
        biodata_id : '',
        file : null,
        userId : '',
        createdAt : '',

      },

      nm_jabatan: "",
      nm_unit_kerja: "",

      instansi_id: "",
      unit_kerja: "",
      unit_kerja_full: "",
      unit_kerja_edit: "",

      filterku: {
        instansi: "",
        unit_kerja: "",
        fileStat: false
      },

      list_data: [],
      list_riwayat : [],

      page_first: 1,
      page_last: 0,
      page_limit: 10,
      cari_value: "",
      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,
      cek_load_data: true,

      mdl_add: false,
      mdl_edit: false,
      mdl_hapus: false,
      mdl_chat: false,
      mdl_maps: false,
      btn_add: false,
      mdl_maps_tambah: false,
      mdl_img: false,
      mdl_lihat_data: false,
      mdl_detil_riwayat: false,
      mdl_detil_riwayat_add: false,
      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,

      file_old : '',
    };
  },
  methods: {
    getData: function() {
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_simpeg_biodata + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          unit_kerja: this.filterku.unit_kerja,
          page_limit: this.page_limit
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.cek_load_data = false;
          // console.log(res_data);
        });
    },

    addData: function(){

      var formData = new FormData();
      formData.append('data_karpeg_id', this.data.data_karpeg_id);
      formData.append('no_registrasi', this.data.no_registrasi);
      formData.append('no_kepegawaian', this.data.no_kepegawaian);
      formData.append('biodata_id', this.data.biodata_id);
      formData.append('file', this.data.file);

      fetch(this.$store.state.url.URL_simpeg_karpeg+'createData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then(res => res.json()).then((data_urusan) => {
          this.alertku("Berhasil Menambah Data!", "blue");
          this.getRiwayat();
      });
    },

    editData: function(){
        var formData = new FormData();
        formData.append('data_karpeg_id', this.data.data_karpeg_id);
        formData.append('no_registrasi', this.data.no_registrasi);
        formData.append('no_kepegawaian', this.data.no_kepegawaian);
        formData.append('biodata_id', this.data.biodata_id);
        formData.append('file', this.data.file);
        formData.append('file_old', this.file_old);

        fetch(this.$store.state.url.URL_simpeg_karpeg+'updateData', {
            method: "POST",
            headers: {
                authorization : 'kikensbatara '+localStorage.token
            },
            body: formData
        }).then((res_data) => {
            this.alertku("Berhasil Mengubah Data!", "amber");
            this.getRiwayat();
        });
    },

    removeData: function(E) {
      fetch(this.$store.state.url.URL_simpeg_karpeg + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ id: this.data.data_karpeg_id, file: this.data.file })
      }).then(res_data => {
        this.Notify(
          "Sukses Menghapus Data",
          "negative",
          "check_circle_outline"
        );
        this.getRiwayat();
      });
    },

    selectData: function(data) {
      this.form.id = data.id;
      this.form.nama = data.nama;
      this.form.nip = data.nip;
      this.form.gelar_depan = data.gelar_depan;
      this.form.gelar_belakang = data.gelar_belakang;
      this.form.ttl = data.ttl;
      this.form.tempat_lahir = data.tempat_lahir;
      this.form.jenis_kelamin = data.jenis_kelamin;
      this.form.status_keluarga = data.status_keluarga;
      this.form.status_keluarga_uraian = data.status_keluarga_uraian;
      this.form.agama = data.agama;
      this.form.agama_uraian = data.agama_uraian;
      this.form.pendidikan_ahir = data.pendidikan_ahir;
      this.form.pendidikan_ahir_uraian = data.pendidikan_ahir_uraian;
      this.form.sekolah = data.sekolah;
      this.form.thn_lulus = data.thn_lulus;
      this.form.tmt_cpns = data.tmt_cpns;
      this.form.gol = data.gol;
      this.form.gol_uraian = data.gol_uraian;
      this.form.tmt_golongan = data.tmt_golongan;
      this.form.jabatan = data.jabatan;
      this.form.tmt_jabatan = data.tmt_jabatan;
      this.form.no_karpeg = data.no_karpeg;
      this.form.taspen = data.taspen;
      this.form.NPWP = data.NPWP;
      this.form.alamat = data.alamat;
      this.form.kota_asal = data.kota_asal;
      this.form.kode_pos = data.kode_pos;
      this.form.kontak = data.kontak;
      this.form.tmt_gol = data.tmt_gol;
      this.form.nm_sekolah = data.nm_sekolah;
      this.form.pendidikan_formal_thn_lulus = data.pendidikan_formal_thn_lulus;
      this.form.unit_kerja = data.unit_kerja;

      this.form.file_old = data.file;
      this.file_old = data.file;

      this.instansi_id = data.instansi_id;
      this.unit_kerja_edit = data.unit_kerja;

      this.cek_edit = true;
      this.nm_unit_kerja = data.nm_unit_kerja;
      this.nm_jabatan = data.nm_jabatan;


      this.data.biodata_id = data.id;
      this.getRiwayat();

      if (data.file == '' || data.file == null || data.file == undefined) {
          this.filterku.fileStat = false
      } else {
          this.filterku.fileStat = true
      }

      // DATA_MASTER.getJabatan(this.form.unit_kerja);
    },

    getRiwayat: function(){
        fetch(this.$store.state.url.URL_simpeg_karpeg+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.form.id,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.list_riwayat = res_data;
          console.log(res_data);
        })
    },
    selectRiwayat: function(data){
        this.data = {
            data_karpeg_id : data.data_karpeg_id,
            no_registrasi : data.no_registrasi,
            no_kepegawaian : data.no_kepegawaian,
            biodata_id : data.biodata_id,
            file : data.file,
            userId : data.userId,
            createdAt : data.createdAt,
        };
        this.file_old = data.file;
    },

    // ====================================== PAGINATE ====================================
      Notify: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
      },
      indexing: function(index) {
        var idx = (this.page_first - 1) * this.page_limit + index;
        return idx;
      },

      cari_data: function() {
        this.page_first = 1;
        this.getData();
      },
      indicatorColor: function(data) {
        if (data == 0) {
          return {
            bg: `bg-orange-2`,
            status: false
          };
        } else if (data == 1) {
          return {
            bg: `bg-blue-1`,
            status: false
          };
        } else if (data == 2) {
          return {
            bg: `bg-red-2`,
            status: true
          };
        }
      },

      alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
      }

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    var get_profile = JSON.parse(localStorage.profile);
    this.filterku.unit_kerja = get_profile.profile.unit_kerja;
    this.filterku.instansi = get_profile.profile.instansi_id;
    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;

    DATA_MASTER.getInstansi();
    DATA_MASTER.getUnitKerja(this.filterku.instansi);
    DATA_MASTER.getGolongan();

    DATA_MASTER.getJK();
    DATA_MASTER.getStatusKeluarga();
    DATA_MASTER.getAgama();
    DATA_MASTER.getStrataIjazah();

    // this.form.unit_kerja = get_profile.profile.unit_kerja;
    this.getData();
  }
};
